import { LayoutAddiScreenMobileLargeMax } from '@addi/foundation/dist/web/layout';
import styled from 'styled-components';
export const StorePreviewMargin = styled.div `
  display: inline-block;
  margin: 0;
  margin-bottom: 15px;

  @media (min-width: ${LayoutAddiScreenMobileLargeMax}) {
    margin-bottom: 40px;
  }
`;
//# sourceMappingURL=store-preview-list.styles.js.map